import { createContext } from 'react';
export const AlertContext = createContext(null);
//# sourceMappingURL=AlertContext.js.map